import {
  DeesElement,
  css,
  cssManager,
  customElement,
  html,
  property,
  type TemplateResult,
} from '@design.estate/dees-element';

import * as domtools from '@design.estate/dees-domtools';
import { demoFunc } from './dees-button-group.demo.js';
import { themeDefaultStyles } from '../../00theme.js';

declare global {
  interface HTMLElementTagNameMap {
    'dees-button-group': DeesButtonGroup;
  }
}

@customElement('dees-button-group')
export class DeesButtonGroup extends DeesElement {
  public static demo = demoFunc;
  public static demoGroups = ['Button'];

  @property()
  accessor label: string = '';

  @property()
  accessor direction: 'horizontal' | 'vertical' = 'horizontal';

  constructor() {
    super();
    domtools.elementBasic.setup();
  }

  public static styles = [
    themeDefaultStyles,
    cssManager.defaultStyles,
    css`
      :host {
        display: inline-block;
        font-family: var(--dees-font-family);
      }

      .button-group {
        display: flex;
        gap: var(--dees-spacing-xs);
        align-items: center;
        padding: var(--dees-spacing-xs);
        background: var(--dees-color-fill-tertiary);
        border: 1px solid var(--dees-color-border-subtle);
        border-radius: var(--dees-radius-lg);
      }

      .button-group.vertical {
        flex-direction: column;
        align-items: stretch;
      }

      .label {
        color: var(--dees-color-text-secondary);
        font-size: var(--dees-font-caption1-size);
        font-family: var(--dees-font-family);
        margin-right: var(--dees-spacing-sm);
        white-space: nowrap;
      }

      .button-group.vertical .label {
        margin-right: 0;
        margin-bottom: var(--dees-spacing-sm);
      }

      ::slotted(*) {
        margin: 0 !important;
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <div class="button-group ${this.direction}">
        ${this.label ? html`<span class="label">${this.label}</span>` : ''}
        <slot></slot>
      </div>
    `;
  }
}
